'use client';

import { type Exploit, getUniqueChainIds } from '@revoke.cash/core/exploits';
import AddressForm from 'components/exploits/AddressForm';
import ExploitChecker from 'components/exploits/ExploitChecker';
import { AddressIdentityContextProvider } from 'lib/hooks/page-context/AddressIdentityContext';
import { AddressPageContextProvider } from 'lib/hooks/page-context/AddressPageContext';
import { useTranslations } from 'next-intl';
import { Suspense, useMemo, useState } from 'react';
import type { Address } from 'viem';

interface Props {
  exploit: Exploit;
}

const ExploitCheckerWrapper = ({ exploit }: Props) => {
  const t = useTranslations();

  const [address, setAddress] = useState<Address | undefined>();
  const chainIds = useMemo(() => getUniqueChainIds(exploit), [exploit]);

  return (
    <Suspense>
      <AddressIdentityContextProvider address={address!}>
        <AddressPageContextProvider address={address!} initialChainId={chainIds[0]}>
          <AddressForm
            onSubmit={setAddress}
            chainIds={chainIds}
            placeholder={t('exploits.subpages.search.placeholder')}
          />
          <ExploitChecker exploit={exploit} />
        </AddressPageContextProvider>
      </AddressIdentityContextProvider>
    </Suspense>
  );
};

export default ExploitCheckerWrapper;
